export const locale = {
    'DIALOG': {
        'SUPPLIER_PRIORITY': {
            'TITLE': 'Supplier order',
            'CONFIRMBUTTON': 'Save',
            'NAME': 'Name',
        },
    }
}